import { Injectable } from '@angular/core';
import { FFmpeg } from '@ffmpeg/ffmpeg'
import { fetchFile, toBlobURL } from '@ffmpeg/util';

const baseURL = 'https://unpkg.com/@ffmpeg/core-mt@0.12.10/dist/esm';


@Injectable({
  providedIn: 'root'
})
export class AudioConverterService {
  ffmpeg: FFmpeg;

  constructor() {
    console.log('Start Audio Converter Service')
    this.ffmpeg = new FFmpeg();
    this.ffmpeg.on('log', message => console.log(message))
    this.loadFFmpeg();
  }

  async loadFFmpeg() {
    if(!this.ffmpeg.loaded) {
      console.log('Load ffmpeg')
/*      await this.ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.wasm`,
          'application/wasm',
        ),
        workerURL: await toBlobURL(
          `${baseURL}/ffmpeg-core.worker.js`,
          'text/javascript',
        ),
      });*/
      this.ffmpeg.load({
        coreURL: await toBlobURL(`${baseURL}/ffmpeg-core.js`, 'text/javascript'),
        wasmURL: await toBlobURL(`${baseURL}/ffmpeg-core.wasm`, 'application/wasm'),
      })
      console.log(`ffmpeg loaded: ${this.ffmpeg.loaded}`)
    }
  }

}
